const uid = () => Math.random().toString(36).slice(2, 10);

export const DEFAULT_MEAL_NAMES = [
  "COLAZIONE",
  "SPUNTINO MATTINA",
  "PRANZO",
  "MERENDA",
  "CENA",
  "PRE NANNA",
];

export const makeMeal = (nome) => ({ id: uid(), nome, foods: [] });

export const makeDiet = (nome) => ({
  id: uid(),
  nome,
  meals: DEFAULT_MEAL_NAMES.map(makeMeal),
});

export const dietLetter = (i) => String.fromCharCode(65 + i);

const cid = () => Math.random().toString(36).slice(2, 10);
export const cloneDiet = (diet, nome) => ({
  id: cid(),
  nome: nome || diet.nome,
  meals: (diet.meals || []).map((m) => ({
    id: cid(),
    nome: m.nome,
    foods: (m.foods || []).map((f) => ({ ...f, id: cid() })),
  })),
});

// Compute a food line item from a raw food and quantity.
// base "pezzo" => values are per piece (factor = pieces); otherwise per 100g (factor = grams/100).
export const foodLine = (food, qty) => {
  const unit = food.base === "pezzo" ? "pezzo" : "g";
  const factor = unit === "pezzo" ? (parseFloat(qty) || 0) : (parseFloat(qty) || 0) / 100;
  const isAnimal = food.tipo === "animale";
  return {
    id: uid(),
    foodId: food.id,
    nome: food.nome,
    categoria: food.categoria,
    tipo: food.tipo,
    unit,
    grammi: parseFloat(qty) || 0,
    kcal: food.kcal * factor,
    carbo: food.carbo * factor,
    grassi: food.grassi * factor,
    protAnimali: isAnimal ? food.proteine * factor : 0,
    protVegetali: isAnimal ? 0 : food.proteine * factor,
    // reference values (per 100g or per piece) so quantity can be recomputed later
    base: {
      kcal: food.kcal,
      carbo: food.carbo,
      grassi: food.grassi,
      proteine: food.proteine,
      tipo: food.tipo,
      unit,
    },
  };
};

export const recomputeLine = (line, qty) => {
  const b = line.base || {
    kcal: 0, carbo: 0, grassi: 0, proteine: 0, tipo: line.tipo, unit: line.unit,
  };
  const unit = line.unit || b.unit || "g";
  const factor = unit === "pezzo" ? (parseFloat(qty) || 0) : (parseFloat(qty) || 0) / 100;
  const isAnimal = b.tipo === "animale";
  return {
    ...line,
    unit,
    grammi: parseFloat(qty) || 0,
    kcal: b.kcal * factor,
    carbo: b.carbo * factor,
    grassi: b.grassi * factor,
    protAnimali: isAnimal ? b.proteine * factor : 0,
    protVegetali: isAnimal ? 0 : b.proteine * factor,
  };
};

export const mealTotals = (meal) =>
  meal.foods.reduce(
    (a, f) => ({
      kcal: a.kcal + f.kcal,
      carbo: a.carbo + f.carbo,
      protAnimali: a.protAnimali + f.protAnimali,
      protVegetali: a.protVegetali + f.protVegetali,
      grassi: a.grassi + f.grassi,
    }),
    { kcal: 0, carbo: 0, protAnimali: 0, protVegetali: 0, grassi: 0 }
  );

export const dietTotals = (diet) =>
  (diet?.meals || []).reduce(
    (a, m) => {
      const t = mealTotals(m);
      return {
        kcal: a.kcal + t.kcal,
        carbo: a.carbo + t.carbo,
        protAnimali: a.protAnimali + t.protAnimali,
        protVegetali: a.protVegetali + t.protVegetali,
        grassi: a.grassi + t.grassi,
      };
    },
    { kcal: 0, carbo: 0, protAnimali: 0, protVegetali: 0, grassi: 0 }
  );
